
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTuneIec as ObiRadarTuneIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-tune-iec.js';
 
 
 

 
 export const ObiRadarTuneIec = createComponent({
   react: React,
   tagName: 'obi-radar-tune-iec',
   elementClass: ObiRadarTuneIecElement,
   events: {
     
   }
  });
 
 